import React from 'react';
import { Chip } from '@mui/material';

const colorMap: Record<string, 'default' | 'success' | 'warning' | 'error' | 'info'> = {
  active: 'success',
  published: 'success',
  success: 'success',
  succeeded: 'success',
  draft: 'warning',
  paused: 'warning',
  pending: 'warning',
  processing: 'warning',
  archived: 'default',
  inactive: 'default',
  suspended: 'error',
  failed: 'error',
  cancelled: 'error',
};

const StatusChip = ({ value }: { value: string }) => {
  const normalized = value.toLowerCase();
  return (
    <Chip
      size="small"
      label={value}
      color={colorMap[normalized] || 'info'}
      variant={colorMap[normalized] === 'default' ? 'outlined' : 'filled'}
      sx={{ textTransform: 'capitalize' }}
    />
  );
};

export default StatusChip;
